import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subject} from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { fuseAnimations } from '@fuse/animations';

import { FclInfoService } from 'app/main/service/fcl-info.service';
import { HomeService } from 'app/main/service/home.service';
import { Router, Params } from '@angular/router';
import { FuseConfigService } from '@fuse/services/config.service';
import { AuthService } from 'app/auth.service';

@Component({
    selector     : 'vehicle-fclInfo',
    templateUrl  : './fcl-info.component.html',
    styleUrls    : ['./fcl-info.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations   : fuseAnimations
})
export class FclInfoComponent implements OnInit, OnDestroy
{
    fclPrice: any[];
    fcl: any[];
    package: any[];
    currency: any[];
    price: any[];
    data = {
        code: '',
        supplier: {
            full_name: '',
        },
        pol: {
            name: '',
        },
        pod: {
            name: '',
        },
        validity: '',
        vessel: {
            name: '',
        },
        name: '',
        load_terminal: {
            name: '',
        },
        depart_time: '',
        discharge_terminal: {
            name: '',
        },
        arrive_time: '',
        transit_time: 0,
    };
    type = '';
    volume;
    detailPanel = true;
    vesselPanel = true;
    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {FclInfoService} _fclInfoService
     * @param {FormBuilder} _formBuilder
     */
    constructor(
        private _fuseConfigService: FuseConfigService,
        private fclInfoService: FclInfoService,
        private _formBuilder: FormBuilder,
        public router: Router,
        private homeService: HomeService,
        private authService: AuthService
    )
    {

        // Set the private defaults
        this._unsubscribeAll = new Subject();
        this._fuseConfigService.config = {
            layout: {
                navbar   : {
                    hidden: this.authService.name == "Guest"
                },
                toolbar  : {
                    hidden: false
                },
                footer   : {
                    hidden: false
                },
                sidepanel: {
                    hidden: true
                }
            }
        };
    }

    ngOnInit(): void
    {
        if(this.homeService.voyage) {
            //this.volume = this.homeService.search.type;
            this.data = this.homeService.voyage;
            if(this.homeService.search){
                this.volume = this.homeService.search.type
            } else if(this.data['unit']){
                this.volume = this.data['unit'];
            } else {
                this.volume = 'All type';
            }
        } else {
            this.router.navigate(['/landingpage/home2']);
        }
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
    goHome(){
        this.homeService.result = [];
        this.router.navigate(['/landingpage/home2'])
    }
  
}
